<template>
  <div class="outer-wrapper">
    <div class="title">
      <p>采购审核</p>
    </div>
    <Tabs>
      <TabPane label="全部申购单" icon="logo-buffer" name="purchase">
        <purchase-list
          :columnsFormatData="columnsFormatPurchase"
          askData="purchasePackageList"
          :refreshData="update_count"
          main_width="100%"
        ></purchase-list>
      </TabPane>
    </Tabs>
    <Modal v-model="modalValue.verify" :width="600" :mask-closable="false">
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="closeModal('verify')"></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>审核采购单</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>审核结果：</td>
              <td>
                <select v-model="newItem.result">
                  <option
                    :value="ele.value"
                    v-for="ele in resultList"
                    :key="ele.value+'verify'"
                  >{{ele.text}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td>
                <textarea type="text" placeholder v-model="newItem.remark"/>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="verify">提交</Button>
        <Button size="large" @click="closeModal('verify')">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import purchaseList from "@/components/Common/PurchaseList.vue";
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");
import dayjs from 'dayjs'
//import goodsExpand from "./goodsExpand.vue";



export default {
  name: "purchaseVerify",
  props: [],
  components: {
    purchaseList,
  },
  data() {
    return {
      update_count: 0,
      newItem:{
        result:"",
        remark:"",
      },
      modalValue: {
        verify: false,
      },
      resultList:[
        {text:'批准',value:"批准"},
        {text:'不批准',value:"不批准"},
      ],
      currentRecordDate:dayjs().format('YYYY-MM-DD'),
      spin:false,
      columnsFormatPurchase:[
        {
          title: "申购单号",
          key: "display_no",
          align: "center",
          width:150,
        },
        {
          title: "包含物品",
          key: "name",
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              p.row.itemlist.map(
                val=>{
                  return h(
                    "p",
                    {
                      props: {
                        title:this.revealProperty(val.property)
                      },
                      style: { textAlign: "left",margin:"5px 0" },
                    },
                    val.name+' × '+val.amount+val.pit
                  )
                }
              )
            );
          }
        },
        {
          title: "下单时间",
          key: "create_time",
          align: "center",
          width:200,
        },
        {
          title: "下单人",
          key: "create_account",
          align: "center",
          width:100,
        },
        {
          title: "申购备注",
          key: "remark",
          align: "center",
          width:150,
          tooltips:true
        },
        {
          title: "审核人",
          key: "verify_account",
          align: "center",
          width:100,
        },
        {
          title: "审核时间",
          key: "verify_time",
          align: "center",
          width:200,
        },
        {
          title: "审核结果",
          key: "verify_result",
          align: "center",
          width:100,
        },
        {
          title: "审核备注",
          key: "verify_remark",
          align: "center",
          width:150,
          tooltips:true
        },
        {
          title: "操作",
          align: "center",
          width: 130,
          render: (h, params) => {
            return h("div", [
            h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "blue",marginRight:"5px" },
                  on: {
                    click: () => {
                      window.open("/item/packageDetail/" + params.row.enid,"_blank");
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "green" },
                  on: {
                    click: () => {
                      this.confirmVerify(params.row);
                    }
                  }
                },
                "审核"
              )
            ]);
          }
        }
        
      ],
    };
  },
  created() {
  },
  methods: {
    confirmVerify(value) {
      this.newItem.id = value.id;
      this.newItem.display_no = value.display_no;
      this.modalValue.verify = true;
    },
    verify() {
      this.$axios
        .post(this.$url + "/purchase", {
          userToken: userToken,
          askData: "verifyPackage",
          item: this.newItem,
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("审核成功！");
            this.modalValue.verify = false;
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    openModal(value) {
      this.modalValue[value] = true;
    },
    closeModal(value) {
      this.modalValue[value] = false;
    },

    revealProperty(value) {
      let tmp;
      if (typeof value === "string" && value.length > 0) {
        tmp = JSON.parse(value);
      } else {
        tmp = {};
      }
      let text = "";
      if (tmp.spec) {
        text += "规格:" + tmp.spec + ";";
      }
      if (tmp.model) {
        text += "型号:" + tmp.model + ";";
      }
      if (tmp.mat) {
        text += "材质:" + tmp.mat + ";";
      }
      if (tmp.volume) {
        text += "容积:" + tmp.volume + ";";
      }
      if (tmp.brand) {
        text += "品牌:" + tmp.brand + ";";
      }
      if (tmp.seller) {
        text += "供货商:" + tmp.seller + ";";
      }
      if (tmp.diameter) {
        text += "外径:" + tmp.diameter + ";";
      }
      if (tmp.bore) {
        text += "内径:" + tmp.bore + ";";
      }
      if (tmp.thickness) {
        text += "壁厚:" + tmp.thickness + ";";
      }
      if (tmp.pressure) {
        text += "压力:" + tmp.pressure + ";";
      }
      if (tmp.standard) {
        text += "标准:" + tmp.standard + ";";
      }
      if (tmp.grade) {
        text += "级别:" + tmp.grade + ";";
      }
      if (tmp.other) {
        text += "其他:" + tmp.other + ";";
      }
      return text;
    },
  },
};
</script>
<style scoped>
.outer-wrapper {
  width: 98%;
  min-width: 1280px;
  margin: 0 auto;
}
.title {
  text-align: center;
  margin: 10px auto;
  font-size: 20px;
}

.sc-content-wrapper{
  width:100%;
}

.inner-content-wrapper{
  width:100%;
}

.cr-form {
  width: 100%;
  border-collapse: collapse;
}

.cr-form td {
  height: 45px;
}

.cr-form td:first-child {
  width:20%;
  text-align: right;
}

.cr-form input,
.cr-form select {
  padding: 0 10px;
  outline: none;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #aaa;
  width:200px;
}

textarea {
  padding: 5px;
  width:80%;
}

</style>